__webpack_require__.p = "https://cdn.n-tv.de/sport/0.66.3/_next/";